var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar-left"},[(!_vm.$slots.left)?_c('div',{staticClass:"back-icon",on:{"click":_vm.handleBack}},[_c('base-icon',{attrs:{"name":"back_dark"}})],1):[_vm._t("left")]],2),_c('div',{staticClass:"nav-bar-title"},[_vm._t("default")],2),_c('div',{staticClass:"nav-bar-right"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }